module.exports = __webpack_public_path__ + "img/6.44de9644.jpg";